"use client"
import SectionPage from "@/components/common/section-page";
import CardTitle from "@/components/common/card-title";
import ImageGallery from "@/components/common/image-gallery";

export default function Page() {

    return (
        <div className={"flex flex-col gap-6 pb-6"}>
            <CardTitle title={<div className={"text-center"}>IFTM TOP RESA 2023: <br/>
                CÔTE D’IVOIRE TOURISME AU RENDEZ-VOUS DE LA GRANDE MESSE</div>}
                       backgroundImgSrc={"/images/actualites/foires-et-salons/baniere.jpeg"}/>

            <SectionPage sectionType={"xl"} className={"my-12"}>
                <div className="markdown-content text-gray-800">

                    <p className="my-4 text-normal leading-relaxed">
                        Ce mardi 03 Octobre 2023, Olivia Grégoire Ministre Français délégué au Tourisme a donné le Top départ de la 45ème édition du Top Résa 2023 à la Porte de Versailles à Paris
                       <br/> Côte d’Ivoire Tourisme, l’Office National du Tourisme a effectué le déplacement à ce grand rendez-vous du Tourisme.
                       <br/> A la Conférence inaugurale qui a eu pour cadre l’espace ARENA du Hall 1 du parc des expositions, la délégation ivoirienne était fortement représentée. A la tête de ladite délégation, Monsieur Angui Prosper, Premier Conseiller à l’Ambassade de Côte d’Ivoire en France représentant SEM Maurice Bandaman l’Ambassadeur. Monsieur Konaté Issiaka , Consul de la Côte d’Ivoire en France était également de la partie.
                       <br/> Après la conférence, les diplomates ivoiriens ont visité avec ravissement le stand ivoirien qui a fière allure.
                       <br/> Tout au long des 3 jours du Salon, différentes activités sont prévues à savoir : la présentation de l’offre touristique ivoirienne par les exposants et les techniciens de Côte d’Ivoire Tourisme, une table ronde sur le tourisme domestique, un B to B avec le top management du tourisme français, une rencontre avec les start-ups, des rencontres B2B , des partages d’expériences
                    </p>
                </div>


                <div className={'mt-8'}>
                    <ImageGallery images={
                        Array.from({ length: 12 }).map((_, index) => ({
                            src: `/images/actualites/foires-et-salons/iftm/gallerie/${index + 1}.jpeg`,
                            alt: `image${index + 1}`,
                            width: 700,
                            height: 700,
                        }))
                    } aspectRatio={"video"} gridClassName={"grid grid-cols-1 md:grid-cols-4 gap-4"} />
                </div>
            </SectionPage>
        </div>
    );
}
